export const ImportIdentifier = {
  TICKET: 'TICKET',
  TICKET_NOTES: 'TICKET_NOTE',
  TICKET_CONVERSATIONS: 'TICKET_CONVERSATION',
  TICKET_WORKLOGS: 'TICKET_WORKLOG',
  TECHNICIAN_GROUP: 'TECHNICIAN_GROUP',
  UNMONITORED_ASSETS: 'UNMONITORED_ASSETS'
};
